import { Helmet } from "react-helmet-async";
import Navigation from "@/components/Navigation";
import Footer from "@/components/Footer";
import HeroCareers from "@/components/careers/HeroCareers";
import CareersForm from "@/components/careers/CareersForm";

const TrabajaConNosotros = () => {
  return (
    <>
      <Helmet>
        <title>Trabaja con Nosotros | MYCING Ltda. - Empleos en Electricidad Industrial</title>
        <meta 
          name="description" 
          content="Únete al equipo de MYCING Ltda. Buscamos electricistas industriales, técnicos y profesionales del sector eléctrico. Envía tu CV y forma parte de una empresa líder." 
        />
        <meta 
          name="keywords" 
          content="empleo electricista, trabajo electricidad industrial, vacantes electricista Santiago, empleo técnico eléctrico, MYCING empleos" 
        />
        <link rel="canonical" href="https://mycing.cl/trabaja-con-nosotros" />
      </Helmet>

      <div className="min-h-screen bg-dark-section">
        <Navigation />
        <HeroCareers />
        <CareersForm />
        <Footer />
      </div>
    </>
  );
};

export default TrabajaConNosotros;
